export * from './incident-rule.component';
